import axios from "axios";
import store from '../store'
import { createImageSizeError, findOversizedImage } from '@/utils/imageUploadLimit'

const instance = axios.create();

instance.defaults.baseURL = "/api";

instance.interceptors.request.use((config) => {
    const oversizedImage = findOversizedImage(config.data);

    if (oversizedImage) {
        return Promise.reject(createImageSizeError(oversizedImage));
    }

    store.commit("security/setLastRequestOn");
    return config;
});

export default instance;